import React from 'react'

const HouseSmall = ({
  image,
  image_alt,
  house_name,
  vendor_name,
  vendor_logo,
  item,
  main_cta_link,
  usp_label
}) => {
  let priceElement = (
    <>
      <span
        className='[ f-d-bl f-t-micro f-t-bold f-c-fo-pri ]'
        data-sel='txt-house-price'>
        Auf Anfrage
      </span>
      <span
        className='[ f-d-bl f-t-micro f-c-fo-mut ]'
        data-sel='txt-house-expst'>
        Preis
      </span>
    </>
  )

  if (/price_ready/.test(main_cta_link) && item.price_ready) {
    priceElement = (
      <>
        <span
          className='[ f-d-bl f-t-micro f-t-bold f-c-fo-pri ]'
          data-sel='txt-house-price'>
          {`ab ${
            item.price_ready && item.price_ready.toLocaleString('DE-de')
          } €`}
        </span>
        <span
          className='[ f-d-bl f-t-micro f-c-fo-mut ]'
          data-sel='txt-house-expst'>
          Schlüsselfertig
        </span>
      </>
    )
  } else if (/price_lego/.test(main_cta_link) && item.price_lego) {
    priceElement = (
      <>
        <span
          className='[ f-d-bl f-t-micro f-t-bold f-c-fo-pri ]'
          data-sel='txt-house-price'>
          {`ab ${item.price_lego && item.price_lego.toLocaleString('DE-de')} €`}
        </span>
        <span
          className='[ f-d-bl f-t-micro f-c-fo-mut ]'
          data-sel='txt-house-expst'>
          Bausatzhaus
        </span>
      </>
    )
  } else if (/price_fitting/.test(main_cta_link) && item.price_fitting) {
    priceElement = (
      <>
        <span
          className='[ f-d-bl f-t-micro f-t-bold f-c-fo-pri ]'
          data-sel='txt-house-price'>
          {`ab ${
            item.price_fitting && item.price_fitting.toLocaleString('DE-de')
          } €`}
        </span>
        <span
          className='[ f-d-bl f-t-micro f-c-fo-mut ]'
          data-sel='txt-house-expst'>
          Ausbauhaus
        </span>
      </>
    )
  }

  if (!/price_/.test(main_cta_link) && item.price) {
    priceElement = (
      <>
        <span
          className='[ f-d-bl f-t-micro f-t-bold f-c-fo-pri ]'
          data-sel='txt-house-price'>
          {`ab ${item.price && item.price.toLocaleString('DE-de')} €`}
        </span>
        <span
          className='[ f-d-bl f-t-micro f-c-fo-mut ]'
          data-sel='txt-house-expst'>
          {item.price_label}
        </span>
      </>
    )
  }

  const labels = {
    next_cheapest: 'Größer',
    next_biggest: 'Günstiger',
    bestseller: 'Bestseller'
  }
  let uspLabel = usp_label ? labels[usp_label] : null

  return (
    <>
      <img
        src={image}
        className='Card-image'
        height='240'
        width='320'
        alt={image_alt}
      />
      {uspLabel ? (
        <span className='[ f-pos-ab f-p-v-010 f-p-h-020 f-c-ba-pri f-c-fo-neu025 ] Card-usp-label'>
          {uspLabel}
        </span>
      ) : null}
      <span className='[ f-d-bl f-p-a-020 f-c-bo-neu025 ] Card-info'>
        <span className='[ f-m-b-010 f-d-flr ]'>
          <span className='Card-info-house-and-vendor-name Card-info-heading '>
            <span className='[ f-d-bl f-t-tbody f-c-fo-ter f-t-ellip ]'>
              {house_name}
            </span>
            <span className='[ f-d-bl f-t-micro f-c-fo-mut ] Card-info-vendor-name'>
              {vendor_name}
            </span>
          </span>
          <span className='Card-info-vendor-logo-wrapper'>
            <img
              src={vendor_logo}
              className='Card-info-vendor-logo'
              alt={vendor_name}
              title={vendor_name}
            />
          </span>
        </span>

        <span className='[ f-d-flr ]'>
          <span className='Card-info-price'>{priceElement}</span>
          <span className='Card-info-area'>
            <span
              className='[ f-d-bl f-t-micro f-t-bold f-c-fo-pri ]'
              data-sel='txt-house-larea'>
              {`${Math.round(item.living_area_total)} m²`}
            </span>
            <span className='[ f-d-bl f-t-micro f-c-fo-mut ]'>Wohnfläche</span>
          </span>
        </span>
      </span>
    </>
  )
}

export default HouseSmall
